import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';
import GlobalStyles from './styles/globalStyles';
import Layout from './components/layout/Layout';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

// Service Pages
import DigitalMarketing from './pages/services/DigitalMarketing';
import AIAnalytics from './pages/services/AIAnalytics';
import BusinessIntelligence from './pages/services/BusinessIntelligence';
import StrategicConsulting from './pages/services/StrategicConsulting';
import SocialMedia from './pages/services/SocialMedia';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            
            {/* Service Pages */}
            <Route path="/services/digital-marketing" element={<DigitalMarketing />} />
            <Route path="/services/ai-analytics" element={<AIAnalytics />} />
            <Route path="/services/business-intelligence" element={<BusinessIntelligence />} />
            <Route path="/services/strategic-consulting" element={<StrategicConsulting />} />
            <Route path="/services/social-media" element={<SocialMedia />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App;
